<script setup lang="ts">
  import { inject, onBeforeMount, ref } from 'vue';

  import { MODULE_INJECTION } from '../Module/Module.keys';
  import { ModuleVariant } from '../Module/Module.types';

  const moduleVariant = ref();

  onBeforeMount(() => {
    const moduleInjectedValues = inject(MODULE_INJECTION.key, MODULE_INJECTION.defaults);
    if (!moduleInjectedValues.variant) {
      throw new Error('ModuleContent must be used within a Module component.');
    }
    moduleVariant.value = moduleInjectedValues.variant.value;
  });
</script>

<template>
  <div
    class="stash-module-footer flex flex-wrap justify-between"
    :class="{
      'rounded-b border-b border-ice-500 px-3 pb-6 pt-0 lg:px-6': moduleVariant === ModuleVariant.Card,
      'rounded bg-white p-3 shadow lg:rounded-t-none lg:px-6 lg:shadow-none':
        moduleVariant === ModuleVariant.Table || moduleVariant === ModuleVariant.List,
      'mb-0 pt-3 lg:pt-6': moduleVariant === ModuleVariant.Box,
    }"
    data-test="stash-module-footer"
  >
    <slot></slot>
  </div>
</template>
